import { useContext } from 'react';
import { PageHeader, Card, Badge } from '../design-system';
import UserProfileContext from '../context/userprofilecontext';
import PasswordCard from '../components/account/PasswordCard';
import TwoFactorCard from '../components/account/TwoFactorCard';
import PasskeysCard from '../components/account/PasskeysCard';
import styles from './page-my-account.module.css';

function deriveRole(userProfile) {
  if (userProfile?.isSuperAdmin) return 'Super Admin';
  if (userProfile?.isOrgAdmin?.()) return 'Org Admin';
  if (userProfile?.isCaseAdmin?.()) return 'Case Admin';
  if (userProfile?.isCaseEditor?.()) return 'Editor';
  if (userProfile?.isCaseContributor?.()) return 'Contributor';
  if (userProfile?.isCaseViewer?.()) return 'Viewer';
  return 'Member';
}

export default function MyAccountPage() {
  const { userProfile } = useContext(UserProfileContext);
  const user = userProfile?.currentUser;

  const fullName = [user?.firstName, user?.lastName].filter(Boolean).join(' ').trim();
  const displayName = fullName || user?.email?.split('@')[0] || 'User';
  const initials = (fullName ? fullName.split(' ').map((n) => n[0]).join('') : displayName.slice(0, 2))
    .toUpperCase()
    .slice(0, 2);
  const role = deriveRole(userProfile);

  return (
    <div className={styles.page}>
      <PageHeader title="My account" subtitle="Manage your sign-in and security settings." />

      <Card padding="lg">
        <div className={styles.profileRow}>
          <span className={styles.avatar} aria-hidden="true">{initials}</span>
          <div className={styles.profileInfo}>
            <div className={styles.profileName}>{displayName}</div>
            <div className={styles.profileEmail}>{user?.email}</div>
          </div>
          <Badge variant="default" size="md">{role}</Badge>
        </div>
      </Card>

      <div className={styles.sections}>
        <PasswordCard username={user?.email} />
        <TwoFactorCard />
        <PasskeysCard />
      </div>
    </div>
  );
}
